'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatedBackground } from './animated-background';
import { scrollTabIntoView } from './helpers';
import styles from './tabs.module.css';
export const ButtonTab = ({ active, 'data-testid': testId, icon, id, index, label, onClick, onKeyDown, ref, setActive })=>{
    return /*#__PURE__*/ _jsxs("button", {
        "aria-controls": `${id}-panel-${index}`,
        "aria-selected": active,
        className: styles.tab,
        "data-testid": testId,
        id: `${id}-tab-${index}`,
        onClick: (e)=>{
            onClick?.(e);
            setActive(index);
            scrollTabIntoView(e.currentTarget);
        },
        onKeyDown: onKeyDown,
        ref: (el)=>{
            if (!ref.current) {
                return;
            }
            ref.current[index] = el;
        },
        role: "tab",
        tabIndex: active ? 0 : -1,
        type: "button",
        children: [
            active && /*#__PURE__*/ _jsx(AnimatedBackground, {
                id: id
            }),
            /*#__PURE__*/ _jsxs("span", {
                style: {
                    viewTransitionName: `${id}-radio-${index}`
                },
                children: [
                    icon,
                    label
                ]
            })
        ]
    });
};

//# sourceMappingURL=button-tab.js.map